const lineHeights = {
    core: {
        "0": "100%",
        "1": "105%",
        "2": "110%",
        "3": "115%",
        "4": "120%",
        "5": "125%",
        "6": "130%",
        "7": "135%",
        "8": "140%",
        "9": "145%",
        "10": "150%",
        "11": "155%",
        "12": "160%",
    },
};
export default lineHeights;
//# sourceMappingURL=lineHeights.js.map